import { render, staticRenderFns } from "./TutorTable.vue?vue&type=template&id=a33e8a54"
import script from "./TutorTable.vue?vue&type=script&lang=ts"
export * from "./TutorTable.vue?vue&type=script&lang=ts"
import style0 from "./TutorTable.vue?vue&type=style&index=0&id=a33e8a54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports